import React from 'react';
import Popup from '../../../../../../components/popup';
import Button from '../../../../../../components/button';
import Icon from '../../../../../../components/icon';
import {toLocalDateTimeWithoutSeconds} from '../../../../../../utils';
import './index.css';

export default function RevertModal({ isOpen, historyItem, onClose, onConfirm, isLoading, error }) {
	if (!isOpen || !historyItem) return null;

	const entry = historyItem.currentContactEntry || historyItem.snapshot || {};
	const contactName = [entry.givenName, entry.familyName].filter(Boolean).join(' ') || entry.email || 'this contact';
	const authorName = historyItem.actionBy?.name || historyItem.actionBy?.email || 'a team member';

	return (
		<Popup onClose={onClose} className="revert-modal-popup">
			<div className="revert-modal-body p-4">
				<div className="text-center mb-3">
					<div className="revert-modal-icon-wrapper">
						<Icon name="history" className="text-warning fa-2x" />
					</div>
					<h3 className="mt-2 mb-1">Revert Contact Change</h3>
					<p className="text-muted">
						Are you sure you want to revert the modifications made to <strong>{contactName}</strong>?
					</p>
				</div>

				<div className="revert-details-card bg-light p-3 rounded mb-3">
					<div className="d-flex justify-content-between mb-1">
						<span className="text-muted">Action:</span>
						<span className="font-weight-bold">{historyItem.changeType}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span className="text-muted">Modified by:</span>
						<span>{authorName}</span>
					</div>
					<div className="d-flex justify-content-between">
						<span className="text-muted">Date:</span>
						<span>{toLocalDateTimeWithoutSeconds(historyItem.createdAt)}</span>
					</div>
				</div>

				{error && (
					<div className="alert alert-danger py-2 mb-3">
						<small>{error.message || 'Failed to revert contact. Please try again.'}</small>
					</div>
				)}

				<div className="alert alert-warning py-2 mb-4">
					<small>
						<Icon name="info-circle" className="mr-1" />
						Reverting will restore the contact to its state immediately preceding this change.
					</small>
				</div>

				<div className="d-flex justify-content-end gap-2">
					<Button className="btn-secondary mr-2" onClick={onClose} disabled={isLoading}>
						Cancel
					</Button>
					<Button className="btn-warning" onClick={() => onConfirm(historyItem.id)} disabled={isLoading}>
						{isLoading ? (
							<span><Icon name="circle-o-notch" animated="spin" className="mr-1" /> Reverting...</span>
						) : (
							<span><Icon name="undo" className="mr-1" /> Revert Change</span>
						)}
					</Button>
				</div>
			</div>
		</Popup>
	);
}
